import { render, staticRenderFns } from "./ModuleDetailHeader.vue?vue&type=template&id=921818f0&scoped=true"
import script from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
export * from "./ModuleDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleDetailHeader.vue?vue&type=style&index=0&id=921818f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921818f0",
  null
  
)

export default component.exports